"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var ValidatorUtils_1 = require("../../../util/ValidatorUtils");
var ModelMetrics_1 = require("../type/ModelMetrics");
var PROGRESSBAR_WIDTH = 338;
var ModelResultKeyMetricTable = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), threshold = _a.sessionThreshold, confusionMatricesClassification = _a.confusionMatricesClassification, modelMetrics = _a.modelMetrics;
    var _b = React.useState(0), f1Score = _b[0], setF1Score = _b[1];
    var _c = React.useState(0), precision = _c[0], setPrecision = _c[1];
    var _d = React.useState(0), recall = _d[0], setRecall = _d[1];
    var _e = React.useState(0), accuracy = _e[0], setAccuracy = _e[1];
    var _f = React.useState(0), mcc = _f[0], setMcc = _f[1];
    var _g = React.useState(0), informedness = _g[0], setInformedness = _g[1];
    var _h = React.useState(0), markedness = _h[0], setMarkedness = _h[1];
    var _j = React.useState(0), gini = _j[0], setGini = _j[1];
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!(0, ValidatorUtils_1.isValidObject)(threshold)) {
            return;
        }
        var modelValidation = modelMetrics === null || modelMetrics === void 0 ? void 0 : modelMetrics.validation;
        var classification = confusionMatricesClassification.find(function (n) { return n.threshold === threshold; });
        setF1Score((_a = classification === null || classification === void 0 ? void 0 : classification.f1Score) !== null && _a !== void 0 ? _a : 0);
        setPrecision((_b = classification === null || classification === void 0 ? void 0 : classification.positivePredictiveValue) !== null && _b !== void 0 ? _b : 0);
        setRecall((_c = classification === null || classification === void 0 ? void 0 : classification.truePositiveRate) !== null && _c !== void 0 ? _c : 0);
        setAccuracy((_d = classification === null || classification === void 0 ? void 0 : classification.accuracy) !== null && _d !== void 0 ? _d : 0);
        setMcc((_e = classification === null || classification === void 0 ? void 0 : classification.matthewsCorrelationCoefficient) !== null && _e !== void 0 ? _e : 0);
        setInformedness((_f = classification === null || classification === void 0 ? void 0 : classification.informedness) !== null && _f !== void 0 ? _f : 0);
        setMarkedness((_g = classification === null || classification === void 0 ? void 0 : classification.markedness) !== null && _g !== void 0 ? _g : 0);
        setGini((_h = modelValidation === null || modelValidation === void 0 ? void 0 : modelValidation.gini) !== null && _h !== void 0 ? _h : 0);
    }, [threshold, confusionMatricesClassification, modelMetrics]);
    var rowPrimary = [
        {
            name: ModelMetrics_1.BinaryMetricsType.F1,
            value: f1Score,
            tooltip: Localize_1.Messages.f1ScoreDescription(),
            fractionDigits: 3,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.PRECISION,
            value: precision,
            tooltip: Localize_1.Messages.precisionDescription(),
            fractionDigits: 3,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.RECALL,
            value: recall,
            tooltip: Localize_1.Messages.tprDescription(),
            fractionDigits: 4,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.ACCURACY,
            value: accuracy,
            tooltip: Localize_1.Messages.accuracyDescription(),
            fractionDigits: 3,
        },
    ];
    var rowSecondary = [
        {
            name: ModelMetrics_1.BinaryMetricsType.MCC,
            value: mcc,
            tooltip: Localize_1.Messages.mccDescription(),
            fractionDigits: 3,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.INFORMEDNESS,
            value: informedness,
            tooltip: Localize_1.Messages.informednessDescription(),
            fractionDigits: 3,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.MARKEDNESS,
            value: markedness,
            tooltip: Localize_1.Messages.markednessDescription(),
            fractionDigits: 3,
        },
        {
            name: ModelMetrics_1.BinaryMetricsType.GINI,
            value: gini,
            tooltip: Localize_1.Messages.modelResultsCrossValidationInfoGINI(),
            fractionDigits: 4,
        },
    ];
    var labels = {
        minLabel: Localize_1.Messages.modelResultScoreMinLabel(),
        maxLabel: Localize_1.Messages.modelResultScoreMaxLabel(),
    };
    var renderItem = function (row, index) {
        return (React.createElement("div", { key: "".concat(row.name, "_").concat(index), className: styles.BinomialPerformanceMetricsRowCell },
            React.createElement(prediction_model_results_viz_1.InfoCardComponent, { title: row.name, value: React.createElement(React.Fragment, null, (0, NumberUtils_1.formatNumericField)({ value: row.value, fractionDigits: row.fractionDigits })), tooltip: row.tooltip }),
            React.createElement(prediction_model_results_viz_1.ProgressBarComponent, { value: row.value, labels: labels, bars: {
                    backgroundColor: prediction_model_results_viz_1.VizColors.grayBackground,
                    barColor: styles.metricsProgressBar,
                }, width: PROGRESSBAR_WIDTH })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "".concat(styles.BinomialPerformanceMetricsRow, " ").concat(styles.BinomialKeyMetricsFirstRow) }, rowPrimary.map(function (row, index) { return renderItem(row, index); })),
        React.createElement("div", { className: styles.BinomialPerformanceMetricsRow }, rowSecondary.map(function (row, index) { return renderItem(row, index); }))));
};
exports.default = ModelResultKeyMetricTable;
//# sourceMappingURL=ModelResultKeyMetricTable.js.map